import { Http } from '@mygpt/app/http';

export interface GetTokenParams {
  code: string;
}

/**
 * 获取token
 * @param params
 * @returns
 */
export const getToken = (params: GetTokenParams) => {
  const { ...rest } = params;
  const { post } = Http.use();
  return post(`/oauth/token`, rest);
};

export interface RefreshTokenParams {
  refresh_token: string;
}

/**
 * 刷新token
 * @param params
 * @returns
 */
export const refreshToken = (params: RefreshTokenParams) => {
  const { ...rest } = params;
  const { post } = Http.use();
  return post(`/oauth/token/refresh`, rest);
};
